import {
  CustomizationDataDto,
  CustomizationDataDtoResponse,
  KSendSuccessResponse,
} from '@asset-metrix/portal-gateway-client-js';
import { MutationFunction, QueryFunction } from '@tanstack/react-query';

import { portalGatewayClient } from '../portalGatewayClient';

type FetchTableCustomizationQueryKey = readonly [string, { widgetId: string }];

export function getTableCustomizationMutationScopeId(widgetId: string): string {
  return `table-customization-${widgetId}`;
}

export const fetchTableCustomization: QueryFunction<
  CustomizationDataDtoResponse | null,
  FetchTableCustomizationQueryKey
> = async ({ queryKey }) => {
  const [, { widgetId }] = queryKey;
  const result = await portalGatewayClient.table.getCustomization(widgetId);

  return result.data;
};

export const mutateTableCustomization: MutationFunction<
  KSendSuccessResponse,
  { widgetId: string; data: CustomizationDataDto }
> = async ({ widgetId, data }) => {
  const response = await portalGatewayClient.table.putCustomization(
    widgetId,
    data
  );

  return response.data;
};

export const deleteTableCustomization: MutationFunction<
  KSendSuccessResponse,
  { widgetId: string }
> = async ({ widgetId }) => {
  const response =
    await portalGatewayClient.table.deleteCustomization(widgetId);

  return response.data;
};
